<template>
<div class="qr-list-page">

    <el-row>
        <el-col :span="24">
            <div class="grid-content bg-purple-light">
                <div class="searchTitle">
                    <b style="font-size: 20px !important;"> QR 주문 </b>
                </div>

                <!-- 조회 조건 영역 -->
                <div class="searchBody">
                    <div class="searchBody_year" style="font-size: 15px !important;">
                        업체명
                    </div>
                    <div class="searchBody">
                        <el-input
                                class="wide-input"
                                style="margin-left: 10px;"
                                placeholder=""
                                v-model="dept_name"
                                clearable
                        >
                        </el-input>
                    </div>
                    <div class="searchBody">
                        <div
                                class="searchBody_brand"
                                style="margin-left: 10px !important;"
                        >
                            <el-button
                                    :loading="loading"
                                    type="primary"
                                    @click="search(true)"
                                    icon="el-icon-search"
                            >조회</el-button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>



    <el-row>
        <el-col :span="24" >
            <div class="grid-content bg-purple-light qr-list-table-panel" >

                <el-table
                        class="qr-list-table"
                        v-loading="loading"
                        ref="multipleTable"
                        :data="tableData"
                        style="width: 100%"
                        border
                        @selection-change="handleSelectionChange"
                        :row-class-name="tableRowClassName"
                        size="small"
                        :row-style="{ minHeight: '42px' }"
                        :cell-style="{ padding: '6px 8px' }"
                        :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '34px',
                          padding: '4px 8px',
                        }"
                >

                      <el-table-column
                        type="selection"
                        width="44"
                        >
                      </el-table-column>

                      <el-table-column
                        property="seq"
                        label="seq"
                        width="70">
                      </el-table-column>

                      <el-table-column
                        property="rfid_get_order_seq"
                        label="발주일련번호"
                        width="120">
                      </el-table-column>


                     <el-table-column
                        property="dept_name"
                        label="업체명"
                        min-width="320"
                        show-overflow-tooltip>
                      </el-table-column>




                      <el-table-column

                        label="QR 발주수량"
                        width="150">

                         <template slot-scope="scope">
                         <el-input
                                  class="table-input"
                                  size="small"
                                  placeholder=""
                                  v-model="scope.row.rfid_order_amount"></el-input>
                         </template>

                      </el-table-column>

                     <el-table-column
                        property="rfid_order_confirm_amount"
                        label="확정 수량"
                        width="120">
                      </el-table-column>



                     <el-table-column
                         label="추가인증코드"
                         width="220"
                         property="add_auth_code"
                         show-overflow-tooltip

                     >
                       <template slot-scope="scope">
                         <el-input
                             class="table-input"
                             size="small"
                             placeholder=""
                             v-model="scope.row.add_auth_code"
                         >
                         </el-input>
                       </template>
                     </el-table-column>
                    </el-table>

                    <div class="pagination"  >

                    <el-pagination
                      small

                      layout="prev, pager, next"
                          :total="totalSize"
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="currentPage"
                          :page-size="pageSize"
                      >
                    </el-pagination>

                      <el-button
                        :loading="loading"
                        type="primary"
                        @click="dialogVisible = true"
                      >발주 저장</el-button>
                    </div>
                </div>
            <!-- div class="grid-content bg-purple-light"> -->
        </el-col>
    </el-row>



  <el-dialog
      :visible.sync="dialogVisible"
      width="25%"
      height="50px"
      :before-close="handleClose">
    <span>저장 하시겠습니까 ?</span>
    <span slot="footer" class="dialog-footer">
    <div class="searchBody">
        <el-button style ="margin-left: 150px" type="primary" @click="save">OK</el-button>
        <el-button type="primary" @click="dialogVisible = false">Cancel</el-button>
    </div>
    </span>
  </el-dialog>

</div>




</template>

<script>
import Axios from 'axios';

  export default {
    created() {

      document.onkeydown = this.NotReload;


      this.$store.commit("dayBefore",0);
      this.requestEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜
      this.$store.commit("dayBefore",7);
      this.requestStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일

      // this.$store.state.accessToken

      if (this.$store.state.userId != 'admin') {
        this.deptSeqOption = this.$store.state.deptSeq;
        this.deptNameOption = this.$store.state.deptName;
      }


      // 페이지로딩시 조회
      this.search();

    },//created
    data() {
      return {
        // table 관련 data
        tableData: [],
        totalData: [],
        multipleSelection: [],
        currentPage: 1,
        pageSize:10,
        totalSize:0,
        // loading 변수 true 이면 loging 화면 보여줌
        loading:false,
        // 조회조건 관련 변수
        brandOptions: [{
          value: 'CW',
          label: 'CW'
        }, {
          value: 'KO',
          label: 'KO'
        }, {
          value: 'CM',
          label: 'CM'
        }, {
          value: 'KS',
          label: 'KS'
        },],
        brandOption: '',
        styleOption :'',
        deptNameOption:'',
        deptSeqOption:0,
        requestStartDateOption:'',
        requestEndDateOption:'',
        statusOption:'',
        loss:'3',
        deptNameDisabled:'false',
        dialogVisible: false,
          dept_name: '',
      }
    },//data//

    methods: {
      NotReload() {
        if ((event.ctrlKey == true && (event.keyCode == 78 || event.keyCode == 82)) || (event.keyCode == 116)) {
          event.keyCode = 0;
          event.cancelBubble = true;
          event.returnValue = false;
        }
      },

      handleClose() {
        this.dialogVisible = false;
      },

      async search(){
        this.loading = true;

        let url = this.$url + '/rfidGetOrder/list';
        var reqJson = new Object();


        reqJson.brand = this.brandOption;
        reqJson.style = this.styleOption;
        reqJson.dept_seq = this.deptSeqOption;
        reqJson.request_start_date = this.requestStartDateOption;
        reqJson.request_end_date = this.requestEndDateOption;
        reqJson.dept_name = this.dept_name;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.rfidGetOrderDto
          this.totalData=[];
          if (res.data.resultCode){
            for(var resData in resDataJson){
              this.totalData.push({
                  seq : resData
                , rfid_get_order_seq: resDataJson[resData]['rfid_get_order_seq']
                , style: resDataJson[resData]['style']
                , color: resDataJson[resData]['color']
                , size: resDataJson[resData]['size']
                , order_degree: resDataJson[resData]['order_degree']
                , brand: resDataJson[resData]['brand']
                , product_amount: resDataJson[resData]['product_amount']
                , rfid_order_amount: resDataJson[resData]['rfid_order_amount']
                , rfid_order_confirm_amount: resDataJson[resData]['rfid_order_confirm_amount']
                , rfid_take_amount: resDataJson[resData]['rfid_take_amount']
                , request_date: resDataJson[resData]['request_date']
                , dept_name: resDataJson[resData]['dept_name']
                , dept_seq: resDataJson[resData]['dept_seq']
                , take_date: resDataJson[resData]['take_date']
                , add_auth_code : resDataJson[resData]['add_auth_code']
              });
            }
            // 전체 데이터 사이즈
            this.totalSize = this.totalData.length;
            // 보여주는 부분만 slice
            this.tableData = this.totalData.slice(0, this.pageSize);
            this.currentPage = 1;
            this.loading = false;
            this.$message.success(this.$store.state.searchSuccess);
          }else {
            this.$message.error(this.$store.state.dataNotFound);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
        .catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      },//search

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      }, //toggleSelection

      // check box click event
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
        //  return 'warning-row';
        } else if (rowIndex === 3) {
        //  return 'success-row';
        }
         console.log(row);
        return '';
      },
      handleSizeChange(val) {
        console.log(`${val} items per page`);
      },

      // pagging event
      handleCurrentChange(val) {
        this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
      },


      save(){

        if (this.multipleSelection.length <= 0)
        {
          this.$message.error(this.$store.state.noDataSelect);
          return ;
        }
        this.dialogVisible = false;
        this.loading = true;
        let url = "";
        url = this.$url + '/rfidGetOrder/rfidOrderReserve';
        // const json = { 'user_id': this.$store.state.userId };

        // for(var resData in this.multipleSelection){
        //   if ( this.multipleSelection[resData]['rfid_order_amount'] * 1 > 100000 ) {
        //     this.$message.error("100,000 이상 발행불가 합니다.");
        //     this.loading = false
        //     return;
        //   }
        //
        // }

        Axios.post(url,
                      this.multipleSelection
                    , this.$store.state.config ).then(res => {

          // console.log("=========================Axios.pos.SAVE================================" );
          // console.log(res.data);

          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // save

      percent(){

        for(var resData in this.tableData) {
          this.tableData[resData]['rfid_order_amount'] =  Math.ceil(this.tableData[resData]['rfid_order_amount'] * 1.03 );
        }

      },
    }, //methods
  } // export default
</script>

<style>
.qr-list-page {
    width: 100%;
    padding: 8px 12px 14px;
    box-sizing: border-box;
    background: #f4f7fb;
}

.qr-list-page .grid-content.bg-purple-light {
    background: #ffffff;
    border: 1px solid #e3e8f0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(31, 45, 61, 0.06);
    overflow: hidden;
}

.qr-list-page .searchTitle {
    min-height: 42px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    border-bottom: 1px solid #edf1f6;
    color: #1f2d3d;
}

.qr-list-page .searchBody {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    min-height: 48px;
    padding: 0 14px;
}

.qr-list-page .searchBody_year {
    min-width: 72px;
    color: #536170;
    font-weight: 700;
}

.qr-list-page .wide-input {
    width: 360px !important;
}

.qr-list-table-panel {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
}

.qr-list-table {
    width: 100% !important;
    font-size: 13px;
}

.qr-list-table .el-table__header th {
    font-weight: 700;
}

.qr-list-table .el-table__body td {
    line-height: 1.45;
    vertical-align: middle;
}

.qr-list-table .cell {
    white-space: normal;
    word-break: keep-all;
}

.qr-list-table .el-table__body tr:hover > td {
    background: #f6f9ff !important;
}

.qr-list-table .table-input {
    width: 100%;
}

.qr-list-table .table-input .el-input__inner,
.qr-list-page .wide-input .el-input__inner {
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
}

.qr-list-page .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 12px;
    border-top: 1px solid #edf1f6;
}

#address {
    height: 25px !important;
    width: 480px !important;
    border: 1px solid #2C5AA0 !important;
    border-radius: 4px !important;
    box-sizing: border-box !important;
    font-size: 9px !important;
    cursor: pointer !important;
    padding: 0 6px !important;
}


</style>
